import React from 'react';
import { Box, Typography } from '@mui/joy';
import { useDroppable } from '@dnd-kit/core';
import { CheckCircle, Archive } from '@phosphor-icons/react';

interface JobDropFooterProps {
  isActive: boolean;
}

export const JobDropFooter: React.FC<JobDropFooterProps> = ({ isActive }) => {
  const { isOver: isOverComplete, setNodeRef: setCompleteRef } = useDroppable({
    id: 'job-complete',
  });

  const { isOver: isOverArchive, setNodeRef: setArchiveRef } = useDroppable({
    id: 'job-archive',
  });

  if (!isActive) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        height: 180,
        backgroundColor: 'background.surface',
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: 'lg',
        zIndex: 1000,
      }}
    >
      {/* Complete Drop Zone */}
      <Box
        ref={setCompleteRef}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          backgroundColor: isOverComplete ? 'success.softBg' : 'transparent',
          borderRight: '1px solid',
          borderColor: 'divider',
          transition: 'background-color 0.2s',
          cursor: 'pointer',
          py: 3,
        }}
      >
        <CheckCircle size={48} color={isOverComplete ? '#0d7a0d' : '#4caf50'} />
        <Typography
          level="h3"
          sx={{
            color: isOverComplete ? 'success.solid' : 'success.main',
            fontWeight: 'bold',
          }}
        >
          Mark as Complete
        </Typography>
      </Box>

      {/* Archive Drop Zone */}
      <Box
        ref={setArchiveRef}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          backgroundColor: isOverArchive ? 'warning.softBg' : 'transparent',
          transition: 'background-color 0.2s',
          cursor: 'pointer',
          py: 3,
        }}
      >
        <Archive size={48} color={isOverArchive ? '#e65100' : '#ff9800'} />
        <Typography
          level="h3"
          sx={{
            color: isOverArchive ? 'warning.solid' : 'warning.main',
            fontWeight: 'bold',
          }}
        >
          Archive Job
        </Typography>
      </Box>
    </Box>
  );
};
